import AppNavigationDrawer from '@/components/AppNavigationDrawer/AppNavigationDrawer.vue';
import AppHeader from '@/components/AppHeader/AppHeader.vue';
export default {
  name: 'AppLayout',
  components: { AppNavigationDrawer, AppHeader },
};
